/*
This computer program, as defined in the Copyright, Designs and Patents Act 1998 and the Software Directive (2009/24/EC), 
is the copyright of Logic Valley Ltd, a wholly owned subsidiary of Marston (Holdings) Ltd. All rights are reserved.
*/
import React, { useState } from 'react'
import {
  customDateTimeRenderer,
  customTextRenderer,
} from '../../../../../components/base/grid/CustomRenderer'
import utils from '../../../../../../utils/utils'

const useManualReviewMovementsGrid = () => {
  const gridRef = React.useRef()
  const [gridApi, setGridApi] = useState(null)

  const onGridReady = (params) => {
    setGridApi(params.api)
  }

  const columns = [
    {
      headerName: 'VRM',
      field: 'vrmNo',
      filter: false,
      sortable: false,
      cellRenderer: customTextRenderer,
    },
    {
      headerName: 'Site',
      field: 'siteName',
      filter: false,
      sortable: false,
      cellRenderer: customTextRenderer,
    },
    {
      headerName: 'Date',
      field: 'transitDate',
      filter: false,
      sortable: false,
      cellRenderer: customTextRenderer,
    },
    {
      headerName: 'Entered Date & Time',
      field: 'entryTime',
      filter: false,
      sortable: false,
      valueGetter: utils?.convertUtcDateTimeToFormattedDateTimeAgGrid,
      cellRenderer: (params) => customDateTimeRenderer(params, 'case'),
    },
    {
      headerName: 'Exit Date & Time',
      field: 'exitTime',
      filter: false,
      sortable: false,
      valueGetter: utils?.convertUtcDateTimeToFormattedDateTimeAgGrid,
      cellRenderer: (params) => customDateTimeRenderer(params, 'case'),
    },
  ]

  const gridRowData = {
    columnDefs: columns,
    rowData: [],
  }

  return {
    gridRef,
    gridApi,
    onGridReady,
    columns,
    gridRowData,
  }
}

export default useManualReviewMovementsGrid
